const STORAGE_KEY_V2 = "tvoy_podarok_pending_music";
/** Старый ключ — читаем для обратной совместимости */
const LEGACY_WS_KEY = "tvoy_podarok_pending_music_ws_event_id";
function normalizeItem(raw) {
    if (!raw || typeof raw !== "object")
        return null;
    const o = raw;
    const ws = o.ws_event_id;
    if (typeof ws !== "string" || !ws.trim())
        return null;
    const sid = o.song_id;
    return {
        ws_event_id: ws.trim(),
        song_id: typeof sid === "number" && Number.isFinite(sid) ? sid : null,
    };
}
function dedupeByWs(list) {
    const seen = new Set();
    const out = [];
    for (const p of list) {
        if (seen.has(p.ws_event_id))
            continue;
        seen.add(p.ws_event_id);
        out.push(p);
    }
    return out;
}
function persistList(list) {
    try {
        if (list.length === 0) {
            sessionStorage.removeItem(STORAGE_KEY_V2);
            sessionStorage.removeItem(LEGACY_WS_KEY);
            return;
        }
        sessionStorage.setItem(STORAGE_KEY_V2, JSON.stringify(list));
        sessionStorage.removeItem(LEGACY_WS_KEY);
    }
    catch {
        /* private mode / quota */
    }
}
/**
 * Все активные ожидания генерации музыки (несколько параллельных треков).
 */
export function getPendingMusicGenerations() {
    try {
        const raw = sessionStorage.getItem(STORAGE_KEY_V2);
        if (raw) {
            const parsed = JSON.parse(raw);
            if (Array.isArray(parsed)) {
                const items = parsed
                    .map(normalizeItem)
                    .filter((x) => x != null);
                return dedupeByWs(items);
            }
            const single = normalizeItem(parsed);
            if (single)
                return [single];
        }
        const leg = sessionStorage.getItem(LEGACY_WS_KEY)?.trim();
        if (leg)
            return [{ ws_event_id: leg, song_id: null }];
        return [];
    }
    catch {
        return [];
    }
}
/**
 * Добавить ожидание (или обновить song_id для того же ws_event_id).
 */
export function addPendingMusicGeneration(payload) {
    const ws = payload.ws_event_id.trim();
    if (!ws)
        return;
    const list = getPendingMusicGenerations();
    if (list.some((p) => p.ws_event_id === ws)) {
        persistList(dedupeByWs(list.map((p) => p.ws_event_id === ws
            ? { ws_event_id: ws, song_id: payload.song_id }
            : p)));
        return;
    }
    persistList(dedupeByWs([
        ...list,
        { ws_event_id: ws, song_id: payload.song_id },
    ]));
}
export function removePendingMusicGeneration(ws_event_id) {
    const ws = ws_event_id.trim();
    const next = getPendingMusicGenerations().filter((p) => p.ws_event_id !== ws);
    persistList(next);
}
/** Совместимость: первый элемент или null */
export function getPendingMusicGeneration() {
    const a = getPendingMusicGenerations();
    return a[0] ?? null;
}
/** Добавляет в очередь ожиданий (не затирает другие треки) */
export function setPendingMusicGeneration(payload) {
    addPendingMusicGeneration(payload);
}
export function clearPendingMusicGeneration() {
    try {
        sessionStorage.removeItem(STORAGE_KEY_V2);
        sessionStorage.removeItem(LEGACY_WS_KEY);
    }
    catch {
        /* */
    }
}
